import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head } from '@inertiajs/react';
import { RotateCw, Timer } from 'lucide-react';

export default function TooManyRequests() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.too_many_requests.title', 'Too many requests')} />
            <ErrorPageLayout
                icon={<Timer />}
                tone="warning"
                code={t('errors.too_many_requests.code', '429')}
                title={t('errors.too_many_requests.title', 'Too many requests')}
                description={t(
                    'errors.too_many_requests.description',
                    "You've made too many requests in a short time. Please wait a moment and try again.",
                )}
                actions={
                    <Button onClick={() => window.location.reload()}>
                        <RotateCw className="mr-2 h-4 w-4" />
                        {t('errors.too_many_requests.retry', 'Try again')}
                    </Button>
                }
            />
        </>
    );
}
